import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';

@Injectable()
export class BaseUrlService {
  constructor(private http: HttpClient, private sharedService: SharedService) {}

  private createEntityUri(): string {
    return `${environment.controlBaseUrl}${
      environment.flowManagerBaseUri
    }/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}/config/baseurls`;
  }

  private getURLParams(): { entityId: string; entityType: string } {
    return {
      entityId: this.sharedService.getEntityId(),
      entityType: this.sharedService.getEntityType(),
    };
  }

  getBaseUrls() {
    return this.http.get(this.createEntityUri());
  }

  addBaseUrl(baseUrl: string) {
    return this.http.post(this.createEntityUri(), { ...this.getURLParams(), baseUrl });
  }

  editBaseUrl(baseUrl: string, referenceId: string) {
    return this.http.put(this.createEntityUri(), { ...this.getURLParams(), baseUrl, referenceId });
  }

  removeBaseUrl(referenceId: string) {
    return this.http.request('delete', this.createEntityUri(), {
      body: { ...this.getURLParams(), referenceId },
    });
  }
}
